exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.table-container[data-v-7c9e95c5]{padding:5px;border:1px dashed #336699;-webkit-box-sizing:border-box;box-sizing:border-box}div.table-container table.table-layout[data-v-7c9e95c5]{width:100%;text-align:center;border-collapse:collapse;table-layout:fixed}div.table-container table.table-layout[data-v-7c9e95c5]  td{height:48px;border:1px dashed #336699;padding:3px;display:table-cell}div.table-container table.table-layout .form-widget-list[data-v-7c9e95c5]{border:1px dashed #336699;min-height:36px}.table-container.selected[data-v-7c9e95c5]{outline:2px solid #409eff !important}\n", ""]);

// exports
